import { Predicates } from "libraries/predicates/predicates";
import {
  ComponentType,
  ICompositionMpnComponent,
  IMpnComposition,
  ITccComposition,
} from "../../../../types/data.interface";
import { CompositionType } from "../mpn-composition-modal/AddMpnCompositionModal";
import { useCreateMpnStore } from "../../context/create/CreateMpnContext";
import TreeActionsGroup from "./TreeActionsGroup";
import { CompositionCheckbox } from "../mpn-composition-modal";
import { Tooltip } from "react-tooltip";

type HighlightColumns = {
  mold: boolean;
  color: boolean;
  decorTech: boolean;
  artwork: boolean;
  material: boolean;
};

export type HighlightsCheckType = "restrictive" | "not-restrictive";

const ComponentsTable = ({
  skuId,
  isSummaryPage,
  isModal,
  isPipPage,
  components,
  componentsType,

  addActionHandler,
  handleRemoveNode,
  openEditModal,

  shouldIncludeSku,
  manageComponentInclusion,
  assertComponentIsIncluded,
  tccComposition,
  highlightsCheckType,
  setCompositionHasHighlights,
}: {
  skuId: string;
  isSummaryPage: boolean;
  isModal: boolean;
  isPipPage: boolean;
  // components: ICompositionComponent[];
  components?: any[];
  componentsType: ComponentType;

  addActionHandler?: (node_id: number, newQuantity: number) => void;
  handleRemoveNode?: (
    node_id: number,
    compositionType: CompositionType,
  ) => void;
  openEditModal?: (
    compositionEditType: CompositionType,
    compositionEditObject: ICompositionMpnComponent | IMpnComposition,
  ) => void;

  shouldIncludeSku: boolean;
  manageComponentInclusion: any;
  assertComponentIsIncluded: any;

  tccComposition: ITccComposition[];
  highlightsCheckType?: HighlightsCheckType;
  setCompositionHasHighlights?: () => void;
}) => {
  const { state, dispatch } = useCreateMpnStore();

  const shouldCompareWithItemNumberComposition: boolean =
    isSummaryPage && !isPipPage && tccComposition.length > 0;

  const compareComponentWithItemNumberComposition = (
    component: ICompositionMpnComponent,
  ): HighlightColumns => {
    if (shouldCompareWithItemNumberComposition) {
      let highlightColumns: HighlightColumns;
      switch (highlightsCheckType) {
        // NOTE: IS COMMENTS BECAUSE WE DON'T NEED TO CONCERN ABOUT THAT RIGHT NOW (01-NOV-2025)
        // case "restrictive":
        //   highlightColumns = restrictiveComparison(component);
        //   break;
        // case "not-restrictive":
        //   highlightColumns = notRestrictiveComparison(component);
        //   break;
        default:
          highlightColumns = {
            mold: false,
            color: false,
            decorTech: false,
            artwork: false,
            material: false,
          };
          break;
      }

      const atLeastOneHighlight = Object.values(highlightColumns).some(
        (value) => value,
      );
      if (
        Predicates.isNotNullAndNotUndefined(setCompositionHasHighlights) &&
        atLeastOneHighlight
      )
        setCompositionHasHighlights();

      return highlightColumns;
    } else {
      return {
        mold: false,
        color: false,
        decorTech: false,
        artwork: false,
        material: false,
      };
    }
  };


  // NOTE: IS COMMENTS BECAUSE WE DON'T NEED TO CONCERN ABOUT THAT RIGHT NOW (01-NOV-2025)
  // const restrictiveComparison = (
  //   component: ICompositionMpnComponent,
  // ): HighlightColumns => {
  //   const validTccCompositionRows: ITccComposition[] = tccComposition.filter(
  //     (compositionRow) =>
  //       (Predicates.isNotNullAndNotUndefined(compositionRow.mold) ||
  //         Predicates.isNotNullAndNotUndefined(compositionRow.nonMold)) &&
  //       Predicates.isNotNullAndNotUndefined(compositionRow.color),
  //   );
  //
  //   const componentHasMoldInValidRows: boolean = validTccCompositionRows
  //     .map((compositionRow) =>
  //       compositionRow.component_type === "Molded"
  //         ? compositionRow.mold?.id
  //         : compositionRow.nonMold?.id,
  //     )
  //     .filter(Predicates.isNotNullAndNotUndefined)
  //     .includes(String(component.mold_id));
  //
  //   const highlightColumns: HighlightColumns = {
  //     mold: false,
  //     color: true,
  //     decorTech: false,
  //     artwork: false,
  //     material: false,
  //   };

  //   if (validTccCompositionRows.length === 0 || !componentHasMoldInValidRows)
  //     return { mold: false, color: false, decorTech: false, artwork: false, material:false };
  //
  //   for (const tccCompositionRow of validTccCompositionRows) {
  //     if (
  //       tccCompositionRow.component_type === "Molded" &&
  //       tccCompositionRow.mold?.id === String(component.mold_id) &&
  //       tccCompositionRow.color?.id === component.color_id
  //     ) {
  //       highlightColumns.color = false;
  //     } else if (
  //       tccCompositionRow.component_type === "NonMolded" &&
  //       tccCompositionRow.nonMold?.id === String(component.mold_id) &&
  //       tccCompositionRow.color?.id === component.color_id
  //     ) {
  //       highlightColumns.color = false;
  //     }
  //   }
  //   return highlightColumns;
  // };

  // const notRestrictiveComparison = (
  //   component: ICompositionComponent,
  // ): HighlightColumns => {
  //   const tccCompositionMolds: IMold[] = tccComposition
  //     .map((composition) => composition.mold)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionNonMolds: IMold[] = tccComposition
  //     .map((composition) => composition.nonMold)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionColors: IColor[] = tccComposition
  //     .map((composition) => composition.color)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionDecor: IDecorationTech[] = tccComposition
  //     .map((composition) => composition.decorTech)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //   const tccCompositionArtworks: IDesign[] = tccComposition
  //     .map((composition) => composition.artwork)
  //     .filter(Predicates.isNotNullAndNotUndefined);
  //
  //   const highlightColumns: HighlightColumns = {
  //     mold: true,
  //     color: true,
  //     decorTech: true,
  //     artwork: true,
  //     material: true,
  //   };
  //
  //   for (const composition of tccComposition) {
  //     if (
  //       (component.type === "Molded" &&
  //         Predicates.isNotNullAndNotUndefined(composition.mold) &&
  //         composition.mold.id === String(component.mold_id)) ||
  //       (component.type === "NonMolded" &&
  //         Predicates.isNotNullAndNotUndefined(composition.nonMold) &&
  //         composition.nonMold.id === String(component.mold_id))
  //     ) {
  //       highlightColumns.mold = false;
  //     }
  //     if (
  //       tccCompositionColors.length === 0 ||
  //       (Predicates.isNotNullAndNotUndefined(composition.color) &&
  //         composition.color.id === component.color_id)
  //     ) {
  //       highlightColumns.color = false;
  //     }
  //     if (
  //       tccCompositionDecor.length === 0 ||
  //       String(component.decoration_technique_id) === "0" ||
  //       (Predicates.isNotNullAndNotUndefined(composition.decorTech) &&
  //         composition.decorTech.id ===
  //           String(component.decoration_technique_id))
  //     ) {
  //       highlightColumns.decorTech = false;
  //     }
  //     if (
  //       tccCompositionArtworks.length === 0 ||
  //       String(component.artwork_id) === "0" ||
  //       (Predicates.isNotNullAndNotUndefined(composition.artwork) &&
  //         composition.artwork.id === String(component.artwork_id) &&
  //         composition.artwork.deco_tech_id ===
  //           String(component.decoration_technique_id))
  //     ) {
  //       highlightColumns.artwork = false;
  //     }
  //   }
  //
  //   return highlightColumns;
  // };
  // END NOTE: IS COMMENTS BECAUSE WE DON'T NEED TO CONCERN ABOUT THAT RIGHT NOW (01-NOV-2025)


  const formatDisplayComponent = (
    componentField: any,
    component: ICompositionMpnComponent,
  ) => {
    if (componentsType === "Molded") {
      if (isPipPage || isModal) {

        if (
          component.full_objects &&
          component.full_objects.hasOwnProperty(componentField)
        ) {
          if (componentField === "material") {
            //@ts-ignore
            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
              //@ts-ignore
              component?.full_objects[componentField]?.four_digit_code,
            )
              ? //@ts-ignore
                `${component.full_objects[componentField]?.four_digit_code} - ${component.full_objects[componentField]?.name}`
              : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                    //@ts-ignore
                    component[componentField + "_id"],
                    //@ts-ignore
                  ) && component[componentField + "_id"] != 0
                ? //@ts-ignore
                  `${component[componentField + "_id"].toString().padStart(4,"0")} - ${component[componentField + "_description"]}`
                : "-";
          }

          if(componentField === "artwork"){
            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
            //@ts-ignore
            component?.full_objects[componentField]?.id,
          )
            ? //@ts-ignore
              `${component.full_objects[componentField]?.id.toString().padStart(4, "0")} - ${component.full_objects[componentField]?.name}`
            : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  //@ts-ignore
                  component[componentField + "_id"],
                  //@ts-ignore
                ) && component[componentField + "_id"] != 0  &&  Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
          }


          return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
            //@ts-ignore
            component?.full_objects[componentField]?.id,
          )
            ? //@ts-ignore
              `${component.full_objects[componentField]?.id} - ${component.full_objects[componentField]?.name}`
            : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  //@ts-ignore
                  component[componentField + "_id"],
                  //@ts-ignore
                ) && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_id"]) && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
        }

          // if (componentField === "mold") {
          //    return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
          //      // @ts-ignore
          //      component["sequence_number"],
          //    )
          //      ? `${component["sequence_number"]} - ${component["mold_description"]}`
          //      : "-";
          //  }

           if (component.hasOwnProperty(`${componentField}_id`)) {
             return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
               //@ts-ignore
               `${component[componentField + "_id"]}`,
             ) &&
               //@ts-ignore
               Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_id"]) &&
               //@ts-ignore
               component[componentField + "_id"] !== undefined && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
           }

        return "-";
      }

      if (component.hasOwnProperty("full_objects")) {
        if (
          component.full_objects &&
          component.full_objects.hasOwnProperty(componentField)
        ) {
          if (componentField === "material") {
            //@ts-ignore
            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
              //@ts-ignore
              component?.full_objects[componentField]?.four_digit_code,
            )
              ? //@ts-ignore
                `${component.full_objects[componentField]?.four_digit_code} - ${component.full_objects[componentField]?.name}`
              : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                    //@ts-ignore
                    component[componentField + "_id"],
                    //@ts-ignore
                  ) && component[componentField + "_id"] != 0 && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
                    ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                  `${component[componentField + "_id"].toString().padStart(4,"0")} - ${component[componentField + "_description"]}`
                : "-";
          }

                    if(componentField === "artwork"){
            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
            //@ts-ignore
            component?.full_objects[componentField]?.id,
          )
            ? //@ts-ignore
              `${component.full_objects[componentField]?.id.toString().padStart(4, "0")} - ${component.full_objects[componentField]?.name}`
            : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  //@ts-ignore
                  component[componentField + "_id"],
                  //@ts-ignore
                ) && component[componentField + "_id"] != 0   &&  Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
          }

          return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
            //@ts-ignore
            component?.full_objects[componentField]?.id,
          )
            ? //@ts-ignore
              `${component.full_objects[componentField]?.id} - ${component.full_objects[componentField]?.name}`
            : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  //@ts-ignore
                  component[componentField + "_id"],
                  //@ts-ignore
                ) && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_id"]) && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
        }
        return "-";
      }


      if (component.hasOwnProperty(`${componentField}_id`)) {

        if(componentField === "artwork"){
                  return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
          //@ts-ignore
          `${component[componentField + "_id"]}`,
          //@ts-ignore
        ) && (`${component[componentField + "_id"]}` !== "null")  &&  Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])   ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"].toString().padStart(4,"0")} - ${component[componentField + "_description"]}`
              : "-";
        }

        return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
          //@ts-ignore
          `${component[componentField + "_id"]}`,
          //@ts-ignore
        ) && (`${component[componentField + "_id"]}` !== "null")  && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"]) ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
      }
      return "-";
    }

    else{
      if (isPipPage || isModal) {
        try {
          if (component && component?.full_objects) {
            if (componentField === "mold") {
              return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                // @ts-ignore
                component?.full_objects.non_mold["sequence_number"],
              )
                ? // @ts-ignore
                  `${component?.full_objects.non_mold["sequence_number"]} - ${component?.full_objects.non_mold["name"]}`
                : "-";
            }

            if (componentField === "material") {
              //@ts-ignore
              return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                //@ts-ignore
                component?.full_objects.non_mold[componentField]
                  ?.four_digit_code,
              )
                ? //@ts-ignore
                  `${component.full_objects.non_mold[componentField]?.four_digit_code} - ${component.full_objects.non_mold[componentField]?.name}`
                : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                      //@ts-ignore
                      component[componentField + "_id"],
                      //@ts-ignore
                    ) && component[componentField + "_id"] != 0 && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
                    ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"].toString().padStart(4,"0")} - ${component[componentField + "_description"]}`
              : "-";
            }

                      if(componentField === "artwork"){
            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
            //@ts-ignore
            component?.full_objects[componentField]?.id,
          )
            ? //@ts-ignore
              `${component.full_objects[componentField]?.id.toString().padStart(4, "0")} - ${component.full_objects[componentField]?.name}`
            : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  //@ts-ignore
                  component[componentField + "_id"],
                  //@ts-ignore
                ) && component[componentField + "_id"] != 0  &&  Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
          }

            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
              //@ts-ignore
              component?.full_objects.non_mold[componentField]?.id,
            )
              ? //@ts-ignore
                `${component.full_objects.non_mold[componentField]?.id} - ${component.full_objects.non_mold[componentField]?.name}`
              : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                    //@ts-ignore
                    component[componentField + "_id"],
                    //@ts-ignore
                  ) && component[componentField + "_id"] != 0 && Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
                 ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
          }

           if (componentField === "mold") {
             return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
               // @ts-ignore
               component["sequence_number"],
             )
               ? `${component["sequence_number"]} - ${component["mold_description"]}`
               : "-";
           }

           if (component.hasOwnProperty(`${componentField}_id`)) {
             return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
               //@ts-ignore
               `${component[componentField + "_id"]}`,
             ) &&
               //@ts-ignore
               component[componentField + "_id"] != 0 &&
               //@ts-ignore
               Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
           }

        } catch (error) {
          console.log(error);
        }
        return "-";
      }

      if (component.hasOwnProperty("full_objects")) {
        if (
          component.full_objects &&
          component.full_objects.non_mold &&
          componentField === "mold"
        ) {
          //@ts-ignore
          return `${component.full_objects.non_mold["sequence_number"]} - ${component.full_objects.non_mold["name"]}`
        }
        if (
          component.full_objects &&
          component.full_objects.non_mold &&
          component.full_objects.non_mold.hasOwnProperty(componentField)
        ) {

        if (
          component.full_objects &&
          componentField === "material"
        ) {
          //@ts-ignore
          return component?.full_objects?.non_mold?.material?.four_digit_code
                //@ts-ignore
              ? `${component?.full_objects?.non_mold?.material?.four_digit_code} - ${component?.full_objects?.non_mold?.material?.name}`
              : "-"
          }

          if(componentField === "artwork"){
            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
            //@ts-ignore
            component?.full_objects[componentField]?.id,
          )
            ? //@ts-ignore
              `${component.full_objects[componentField]?.id.toString().padStart(4, "0")} - ${component.full_objects[componentField]?.name}`
            : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  //@ts-ignore
                  component[componentField + "_id"],
                  //@ts-ignore
                ) && component[componentField + "_id"] != 0  &&  Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
              ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
              : "-";
          }


          return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
            //@ts-ignore
            component?.full_objects.non_mold[componentField]?.id,
          )
            ? //@ts-ignore
              `${component.full_objects.non_mold[componentField]?.id} - ${component.full_objects.non_mold[componentField]?.name}`
            : Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  //@ts-ignore
                  component.full_objects.non_mold[componentField + "_id"],
                ) &&
                //@ts-ignore
                component.full_objects.non_mold[componentField + "_id"] != 0 && //@ts-ignore
                component.full_objects.non_mold[componentField + "_id"] !==
                  undefined
                ?
              //@ts-ignore
            component.full_objects.non_mold[componentField + "_description"].split("-").length > 1 ? component.full_objects.non_mold[componentField + "_description"] :
              //@ts-ignore
                `${component.full_objects.non_mold[componentField + "_id"]} - ${component.full_objects.non_mold[componentField + "_description"]}`
              : "-";
        }

        return "-";
      }

      if (componentField === "mold") {
        return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
          // @ts-ignore
          component["sequence_number"],
        )
          ? `${component["sequence_number"]} - ${component["mold_description"]}`
          : "-";
      }

           if (componentField === "material") {
            return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
          //@ts-ignore
          `${component[componentField + "_id"]}`,
        ) &&
          //@ts-ignore
          component[componentField + "_id"] != 0 &&
          //@ts-ignore
          Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
                 ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
            `${(component[componentField + "_id"]).toString().padStart(4,"0")} - ${component[componentField + "_description"]}`
          : "-";
      }

      if (component.hasOwnProperty(`${componentField}_id`)) {

          if(componentField === "artwork"){
                  return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
          //@ts-ignore
          `${component[componentField + "_id"]}`,
          //@ts-ignore
        ) && (`${component[componentField + "_id"]}` !== "null") &&  Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"]) ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
                `${component[componentField + "_id"].toString().padStart(4,"0")} - ${component[componentField + "_description"]}`
              : "-";
        }

        return Predicates.isNotNullAndNotUndefinedAndNotEmpty(
          //@ts-ignore
          `${component[componentField + "_id"]}`,
        ) &&
          //@ts-ignore
          component[componentField + "_id"] != 0 &&
          //@ts-ignore
          Predicates.isNotNullAndNotUndefinedAndNotEmpty(component[componentField + "_description"])
                 ?
              //@ts-ignore
            component[componentField + "_description"]?.split("-")?.length > 1   && component[componentField + "_description"]?.split("-", 1)[0].includes(component[componentField + "_id"])  ? component[componentField + "_description"] :
              //@ts-ignore
            `${component[componentField + "_id"]} - ${component[componentField + "_description"]}`
          : "-";
      }
    }
    return "-";

  };

  return (
    <table className="table table-striped mb-0 sku-composition-components-table">
      <thead>
        <tr>
          {isModal && !isSummaryPage && <th scope="col"></th>}
          {/*<th scope="col" className="component-col">*/}
          {/*  Component Type*/}
          {/*</th>*/}
          <th scope="col" className="pcs-col">
            {componentsType === "Molded" && "Mold"}
            {componentsType !== "Molded" && "Sequence"}
          </th>
          <th scope="col" className="artwork-col">
            Mkt Mat Type
          </th>
          <th scope="col" className="material-col">
            Material
          </th>
          <th scope="col" className="mold-index-col">
            Color
          </th>
          <th scope="col" className="mold-index-col">
            Pcs./ Set.
          </th>
          <th scope="col" className="mold-index-col">
            Deco Tech
          </th>
          <th scope="col" className="mold-index-col">
            Artwork
          </th>
          <th scope="col" className="mold-index-col">
            TPS
          </th>
          <th scope="col" className="mold-index-col">
            Index
          </th>
          {    !isSummaryPage &&
                !isModal &&
                addActionHandler &&
                openEditModal &&
                handleRemoveNode && (
            <th scope="col" className="mold-index-col">
              Actions
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        <tr></tr>
        {components?.map((component: ICompositionMpnComponent) => {

          //@ts-ignore
          const componentColorFamily = component.hasOwnProperty("color_family_name") && component?.color_family_name

          // @ts-ignore
          return (
            <tr key={component.node_id}>
              {isModal && !isSummaryPage && (
                <td>
                  <CompositionCheckbox
                    nodeId={component.node_id ?? -1}
                    isDisabled={shouldIncludeSku}
                    isChecked={assertComponentIsIncluded(
                      component.type,
                      component.node_id,
                    )}
                    checkedChangeHandler={manageComponentInclusion}
                  />
                </td>
              )}
              <td>
                {isPipPage && componentsType !== "NonMolded"  ?
                   (<a
                    className="fw-bold"
                    target="_blank"
                    href={`${
                      process.env.REACT_APP_MOLD_APP_URL
                    }/ords/moldapp/product_master.prod_mold_list?moldid=${component.mold_id}&p_prodid=${skuId}`}
                  >
                     <span>{formatDisplayComponent("mold", component)}</span>

                </a>) :
                  <span>{formatDisplayComponent("mold", component)}</span> }
              </td>
              <td>{formatDisplayComponent("marketing_material", component)}</td>
              <td>{formatDisplayComponent("material", component)}</td>
              <td>
                <Tooltip
                  id="color-family-tooltip"
                  className="tooltip-text-box"
                  place="top"
                  noArrow={true}
                />
                <span
                  className="tooltip-span p-0 ml-0"
                  data-tooltip-id="color-family-tooltip"
                  data-tooltip-html={
                    // @ts-ignore
                    componentColorFamily
                      // @ts-ignore
                      ? componentColorFamily
                      : null
                  }
                >
                  {formatDisplayComponent("color", component)}
                </span>
              </td>
              <td>{component.nr_pieces}</td>
              <td>
                {formatDisplayComponent("decoration_technique", component)}
              </td>
              <td>{formatDisplayComponent("artwork", component)}</td>
              <td>{component.is_tps ? "Y" : "N"}</td>
              <td>{component?.mold_index}</td>

              {//@ts-ignore
                !isSummaryPage &&
                !isModal &&
                addActionHandler &&
                openEditModal &&
                handleRemoveNode && (
                <td>
                  <TreeActionsGroup
                    node={component}
                    isMainPage={!isModal}
                    compositionType="component"
                    addActionHandler={() => {}}
                    editActionHandler={() =>
                      //@ts-ignore
                      openEditModal("component", component)
                    }
                    removeActionHandler={() =>
                      //@ts-ignore
                      handleRemoveNode(component, "component")
                    }
                    isMandatory={component.isMandatory !== "Y"}
                  />
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ComponentsTable;
